// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const MailSmall: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 12 8"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="12"
            height="8"
            fill="currentColor"
        >
            <path
                d="M1195.84879,630 C1196.39986,630 1196.85817,630.386076 1196.95306,630.895146 C1196.98128,630.945076 1196.99795,631.001783 1196.99982,631.061134 C1197.00146,631.113038 1196.99167,631.163598 1196.97216,631.209952 L1196.97108,636.909091 C1196.97108,637.511583 1196.46861,638 1195.84879,638 L1186.12229,638 C1185.50247,638 1185,637.511583 1185,636.909091 L1185,631.090909 C1185,630.488417 1185.50247,630 1186.12229,630 L1195.84879,630 Z M1196.222,631.768 L1191.60654,634.76 C1191.42288,634.879977 1191.20682,634.944498 1190.98554,634.945455 C1190.76426,634.944498 1190.5482,634.879977 1190.36454,634.76 L1185.748,631.768 L1185.74819,636.909091 C1185.74819,637.109922 1185.91568,637.272727 1186.12229,637.272727 L1195.84879,637.272727 C1196.0554,637.272727 1196.22289,637.109922 1196.22289,636.909091 L1196.222,631.768 Z M1195.84879,630.727273 L1186.12229,630.727273 C1185.97691,630.727273 1185.85091,630.807877 1185.78899,630.925616 L1190.77979,634.156364 C1190.90464,634.236284 1191.06644,634.236284 1191.19129,634.156364 L1196.18209,630.925616 C1196.12017,630.807877 1195.99417,630.727273 1195.84879,630.727273 Z"
                transform="translate(-1185 -630)"
            />
        </svg>
    );
};

export default React.memo(MailSmall);
